function isArrayBuffer(value) {
    return value instanceof ArrayBuffer;
}

export { isArrayBuffer };
